// constants/permissions.ts

import dashBoardIcon from "../assets/svg/Nav/dashBoardIcon.svg";
import userMangeIcon from "../assets/svg/Nav/userMangeIcon.svg";
import enqueryIcon from "../assets/svg/Nav/enqueryIcon.svg";
import eventIcon from "../assets/svg/Nav/eventIcon.svg";
import supplierIcon from "../assets/svg/Nav/supplierIcon.svg";
import venueIcon from "../assets/svg/Nav/venueIcon.svg";
import customerIcon from "../assets/svg/Nav/customerIcon.svg";
import reportIcon from "../assets/svg/Nav/reportIcon.svg";
import paymentIcon from "../assets/svg/Nav/paymentIcon.svg";
import settingIcon from "../assets/svg/Nav/settingIcon.svg";

// Module definitions with their submodules and default permissions
export const MODULE_PERMISSIONS = {
    DASHBOARD: {
      id: 'dashboard',
      name: 'Dashboard',
      icon: 'dashBoardIcon',
      route: '/dashboard',
      sections: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          actions: {
            view: true,
            edit: false,
            block: false
          }
        }
      ]
    },
    USER_MANAGEMENT: {
      id: 'user-list',
      name: 'User Management',
      icon: 'userMangeIcon',
      route: '/user-list',
      sections: [
        {
          id: 'user-list',
          title: 'User List',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        }
      ]
    },
    ENQUIRIES: {
      id: 'enquiries',
      name: 'Enquiries',
      icon: 'enqueryIcon',
      route: '/enquiries-list',
      sections: [
        {
          id: 'enquiries-list',
          title: 'Enquiry List',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'enquiries',
          title: 'Enquiries',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'client-management',
          title: 'Client Management',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'venue-template',
          title: 'Venue Template',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'supplier-template',
          title: 'Supplier Template',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'client-template',
          title: 'Client Template',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'shortlisting',
          title: 'Shortlisting',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'confirmed-services',
          title: 'Confirmed Services',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'timing',
          title: 'Timing',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'pricing',
          title: 'Pricing',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'booking-form',
          title: 'Booking Form',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'invoice',
          title: 'Invoice',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        }
      ]
    },
    EVENT_PLANNING: {
      id: 'event-list',
      name: 'Event Planning',
      icon: 'eventIcon',
      route: '/event-list',
      sections: [
        {
          id: 'event-list',
          title: 'Planner List',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'client-details',
          title: 'Client Details',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'checklist',
          title: 'Checklist',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'venue-details',
          title: 'Venue Details',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'supplier-details',
          title: 'Supplier Details',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'function-sheet',
          title: 'Function Sheet',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        }
      ]
    },
    SUPPLIER_MANAGEMENT: {
      id: 'supplier-list',
      name: 'Supplier Management',
      icon: 'supplierIcon',
      route: '/supplier-list',
      sections: [
        {
          id: 'supplier-list',
          title: 'Supplier List',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        }
      ]
    },
    VENUE_MANAGEMENT: {
      id: 'venue-list',
      name: 'Venue Management',
      icon: 'venueIcon',
      route: '/venue-list',
      sections: [
        {
          id: 'venue-list',
          title: 'Venue List',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        }
      ]
    },
    CUSTOMER_MANAGEMENT: {
      id: 'customer-list',
      name: 'Customer Management',
      icon: 'customerIcon',
      route: '/customer-list',
      sections: [
        {
          id: 'customer-list',
          title: 'Customer List',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        }
      ]
    },
    REPORTS: {
      id: 'report-management',
      name: 'Reports',
      icon: 'reportIcon',
      route: '/report-management',
      sections: [
        {
          id: 'report-overview',
          title: 'Report overview',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'event-status-report',
          title: 'Event Status Report',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'sales-performance-tracking',
          title: 'Sales Performance Tracking',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        },
        {
          id: 'profit-loss',
          title: 'Profit & Loss',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        }
      ]
    },
    PAYMENTS: {
      id: 'payments',
      name: 'Payments',
      icon: 'paymentIcon',
      route: '/payments',
      sections: []
    },
    SETTINGS: {
      id: 'settings',
      name: 'Settings',
      icon: 'settingIcon',
      route: '/settings',
      sections: [
        {
          id: 'settings',
          title: 'Settings',
          actions: {
            view: true,
            edit: true,
            block: false
          }
        }
      ]
    }
  } as const;
  
  // Navbar configuration for easy mapping
  export const NAV_ITEMS = [
    {
      id: 1,
      moduleName: MODULE_PERMISSIONS.DASHBOARD.name,
      toolTipName: MODULE_PERMISSIONS.DASHBOARD.name,
      menuImg: dashBoardIcon, // This will be imported in the component
      route: MODULE_PERMISSIONS.DASHBOARD.route,
      label: MODULE_PERMISSIONS.DASHBOARD.id,
      moduleKey: 'DASHBOARD'
    },
    {
      id: 2,
      moduleName: MODULE_PERMISSIONS.USER_MANAGEMENT.name,
      toolTipName: MODULE_PERMISSIONS.USER_MANAGEMENT.name,
      menuImg: userMangeIcon,
      route: MODULE_PERMISSIONS.USER_MANAGEMENT.route,
      label: MODULE_PERMISSIONS.USER_MANAGEMENT.id,
      moduleKey: 'USER_MANAGEMENT'
    },
    {
      id: 3,
      moduleName: MODULE_PERMISSIONS.ENQUIRIES.name,
      toolTipName: MODULE_PERMISSIONS.ENQUIRIES.name,
      menuImg: enqueryIcon,
      route: MODULE_PERMISSIONS.ENQUIRIES.route,
      label: MODULE_PERMISSIONS.ENQUIRIES.id,
      moduleKey: 'ENQUIRIES'
    },
    {
      id: 4,
      moduleName: MODULE_PERMISSIONS.EVENT_PLANNING.name,
      toolTipName: MODULE_PERMISSIONS.EVENT_PLANNING.name,
      menuImg: eventIcon,
      route: MODULE_PERMISSIONS.EVENT_PLANNING.route,
      label: MODULE_PERMISSIONS.EVENT_PLANNING.id,
      moduleKey: 'EVENT_PLANNING'
    },
    {
      id: 5,
      moduleName: MODULE_PERMISSIONS.SUPPLIER_MANAGEMENT.name,
      toolTipName: MODULE_PERMISSIONS.SUPPLIER_MANAGEMENT.name,
      menuImg: supplierIcon,
      route: MODULE_PERMISSIONS.SUPPLIER_MANAGEMENT.route,
      label: MODULE_PERMISSIONS.SUPPLIER_MANAGEMENT.id,
      moduleKey: 'SUPPLIER_MANAGEMENT'
    },
    {
      id: 6,
      moduleName: MODULE_PERMISSIONS.VENUE_MANAGEMENT.name,
      toolTipName: MODULE_PERMISSIONS.VENUE_MANAGEMENT.name,
      menuImg: venueIcon,
      route: MODULE_PERMISSIONS.VENUE_MANAGEMENT.route,
      label: MODULE_PERMISSIONS.VENUE_MANAGEMENT.id,
      moduleKey: 'VENUE_MANAGEMENT'
    },
    {
      id: 7,
      moduleName: MODULE_PERMISSIONS.CUSTOMER_MANAGEMENT.name,
      toolTipName: MODULE_PERMISSIONS.CUSTOMER_MANAGEMENT.name,
      menuImg: customerIcon,
      route: MODULE_PERMISSIONS.CUSTOMER_MANAGEMENT.route,
      label: MODULE_PERMISSIONS.CUSTOMER_MANAGEMENT.id,
      moduleKey: 'CUSTOMER_MANAGEMENT'
    },
    {
      id: 8,
      moduleName: MODULE_PERMISSIONS.REPORTS.name,
      toolTipName: MODULE_PERMISSIONS.REPORTS.name,
      menuImg: reportIcon,
      route: MODULE_PERMISSIONS.REPORTS.route,
      label: MODULE_PERMISSIONS.REPORTS.id,
      moduleKey: 'REPORTS'
    },
    {
      id: 9,
      moduleName: MODULE_PERMISSIONS.PAYMENTS.name,
      toolTipName: MODULE_PERMISSIONS.PAYMENTS.name,
      menuImg: paymentIcon,
      route: MODULE_PERMISSIONS.PAYMENTS.route,
      label: MODULE_PERMISSIONS.PAYMENTS.id,
      moduleKey: 'PAYMENTS'
    },
    {
      id: 10,
      moduleName: MODULE_PERMISSIONS.SETTINGS.name,
      toolTipName: MODULE_PERMISSIONS.SETTINGS.name,
      menuImg: settingIcon,
      route: MODULE_PERMISSIONS.SETTINGS.route,
      label: MODULE_PERMISSIONS.SETTINGS.id,
      moduleKey: 'SETTINGS'
    }
  ] as const;
  
  // Permission utility functions
  export const hasModuleAccess = (
    userPermissions: any[],
    moduleName: string,
    userRole?: string
  ): boolean => {
    // Admin has full access
    if (userRole === 'admin') return true;
    
    // Dashboard is always accessible
    // if (moduleName === MODULE_PERMISSIONS.DASHBOARD.name) return true;
    
    const permission = userPermissions?.find(
      (p: any) => p.module === moduleName
    );
    
    // Check the hasPermission flag at the module level
    // return permission?.section?.some((sec: any) => sec.actions?.view) ?? false
    return permission?.hasPermission === true;
  };
  
  export const hasSectionAccess = (
    userPermissions: any[],
    moduleName: string,
    sectionTitle: string,
    action: 'view' | 'edit' | 'block' = 'view',
    userRole?: string
  ): boolean => {
    // Admin has full access to all actions
    if (userRole === 'admin') return true;
    
    const modulePermission = userPermissions?.find(
      (p: any) => p.module === moduleName
    );
    
    if (!modulePermission) return false;
    
    const section = modulePermission.section?.find(
      (s: any) => s.title === sectionTitle
    );
    
    return section?.actions?.[action] ?? false;
  };
  
  export const getAccessibleModules = (
    userPermissions: any[],
    userRole?: string,
    navItems = NAV_ITEMS
  ) => {
    // Admin sees all modules
    if (userRole === 'admin') return navItems;
    
    return navItems.filter((menu) => {
      // Always include dashboard
      // if (menu.moduleName === MODULE_PERMISSIONS.DASHBOARD.name) return true;
      
      // Restrict Reports only to admin
      // if (menu.moduleName === MODULE_PERMISSIONS.REPORTS.name) return false;
      
      return hasModuleAccess(userPermissions, menu.moduleName, userRole);
    });
  };
  
  // Type definitions
  export type ModuleKey = keyof typeof MODULE_PERMISSIONS;
  export type Module = typeof MODULE_PERMISSIONS[ModuleKey];
  export type Section = Module['sections'][0];
  export type ActionType = 'view' | 'edit' | 'block';
  
  export interface UserPermission {
    hasPermission: boolean;
    _id: string;
    module: string;
    section: Array<{
      actions: {
        view: boolean;
        edit: boolean;
        block: boolean;
      };
      _id: string;
      title: string;
    }>;
  }

  export const ENQUIRY_TAB_CONFIG = {
    B2C: {
      toggleValue: 'B2C',
      tabs: [
        { sectionId: 'enquiries', sectionTitle: 'Enquiries', component: 'EnquiryTab', index: 0 },
        { sectionId: 'client-management', sectionTitle: 'Client Management', component: 'ClientManagement', index: 1 },
        { sectionId: 'venue-templates', sectionTitle: 'Venue Template', component: 'VenueTemplates', index: 2 },
        { sectionId: 'supplier-templates', sectionTitle: 'Supplier Template', component: 'Suppliertemplates', index: 3 },
        { sectionId: 'client-templates', sectionTitle: 'Client Template', component: 'ClientTemplate', index: 4 },
        { sectionId: 'shortlisting', sectionTitle: 'Shortlisting', component: 'Shortlisting', index: 5 },
        { sectionId: 'confirmed-services', sectionTitle: 'Confirmed Services', component: 'ConfirmedServices', index: 6 },
        { sectionId: 'timing', sectionTitle: 'Timing', component: 'Timing', index: 7 },
        { sectionId: 'pricing', sectionTitle: 'Pricing', component: 'Pricing', index: 8 },
        { sectionId: 'booking-form', sectionTitle: 'Booking Form', component: 'BookingForm', index: 9 },
        { sectionId: 'invoice', sectionTitle: 'Invoice', component: 'Invoice', index: 10 }
      ]
    },
    B2B: {
      toggleValue: 'B2B',
      tabs: [
        { sectionId: 'company-management', sectionTitle: 'Company Management', component: 'CompanyManagement', index: 11 },
        { sectionId: 'client-management', sectionTitle: 'Client Management', component: 'ClientManagement', index: 12 }
      ]
    }
  } as const;

// Enhanced utility function for getting accessible enquiry tabs
export const getAccessibleEnquiryTabs = (
  userPermissions: any[],
  userRole?: string,
  toggleValue: 'B2C' | 'B2B' = 'B2C'
) => {
  // Admin has full access to all tabs
  if (userRole === 'admin') {
    return ENQUIRY_TAB_CONFIG[toggleValue].tabs;
  }

  // Find Enquiries module permissions
  const modulePermissions = userPermissions?.find(
    (p: any) => p.module === MODULE_PERMISSIONS.ENQUIRIES.name
  );

  // If no permissions for Enquiries module, return empty array
  if (!modulePermissions || !modulePermissions.hasPermission) {
    return [];
  }

  // Filter tabs based on section permissions
  return ENQUIRY_TAB_CONFIG[toggleValue].tabs.filter((tabConfig) => {
    const section = modulePermissions.section?.find(
      (s: any) => s.title === tabConfig.sectionTitle
    );
    
    // Check if user has view permission for this section
    return section?.actions?.view ?? false;
  });
};

export const EVENT_PLANNING_TAB_CONFIG = {
  tabs: [
    { sectionId: 'client-details', sectionTitle: 'Client Details', component: 'ClientDetailsTab', index: 0 },
    { sectionId: 'checklist', sectionTitle: 'Checklist', component: 'CheckListTab', index: 1 },
    { sectionId: 'venue-details', sectionTitle: 'Venue Details', component: 'VenueDetails', index: 2 },
    { sectionId: 'supplier-details', sectionTitle: 'Supplier Details', component: 'SupplierDetails', index: 3 },
    { sectionId: 'function-sheet', sectionTitle: 'Function Sheet', component: 'FunctionSheet', index: 4 }
  ]
} as const;

// Utility function for getting accessible Event Planning tabs
export const getAccessibleEventPlanningTabs = (
  userPermissions: any[],
  userRole?: string
) => {
  // Admin has full access to all tabs
  if (userRole === 'admin') {
    return EVENT_PLANNING_TAB_CONFIG.tabs;
  }

  // Find Event Planning module permissions
  const modulePermissions = userPermissions?.find(
    (p: any) => p.module === MODULE_PERMISSIONS.EVENT_PLANNING.name
  );

  // If no permissions for Event Planning module, return empty array
  if (!modulePermissions || !modulePermissions.hasPermission) {
    return [];
  }

  // Filter tabs based on section permissions
  return EVENT_PLANNING_TAB_CONFIG.tabs.filter((tabConfig) => {
    const section = modulePermissions.section?.find(
      (s: any) => s.title === tabConfig.sectionTitle
    );
    
    // Check if user has view permission for this section
    return section?.actions?.view ?? false;
  });
};

export const REPORTS_TAB_CONFIG = {
  tabs: [
    { sectionId: 'report-overview', sectionTitle: 'Report overview', component: 'ReportOverview', index: 0 },
    { sectionId: 'event-status-report', sectionTitle: 'Event Status Report', component: 'EventStatusReports', index: 1 },
    { sectionId: 'sales-performance-tracking', sectionTitle: 'Sales Performance Tracking', component: 'SalesPerformanceTracking', index: 2 },
    { sectionId: 'profit-loss', sectionTitle: 'Profit & Loss', component: 'ProfitAndLoss', index: 3 }
  ]
} as const;

// Utility function for getting accessible Reports tabs
export const getAccessibleReportsTabs = (
  userPermissions: any[],
  userRole?: string
) => {
  // Admin has full access to all tabs
  if (userRole === 'admin') {
    return REPORTS_TAB_CONFIG.tabs.map(tab => ({
      ...tab,
      actions: { view: true, edit: true, block: false }
    }));
  }

  // Find Reports module permissions
  const modulePermissions = userPermissions?.find(
    (p: any) => p.module === MODULE_PERMISSIONS.REPORTS.name
  );

  // If no permissions for Reports module, return all tabs with default false actions
  if (!modulePermissions || !modulePermissions.hasPermission) {
    return REPORTS_TAB_CONFIG.tabs.map(tab => ({
      ...tab,
      actions: { view: false, edit: false, block: false }
    }));
  }

  // Return ALL tabs with their actual permissions (no filtering!)
  return REPORTS_TAB_CONFIG.tabs.map((tabConfig) => {
    const section = modulePermissions.section?.find(
      (s: any) => s.title === tabConfig.sectionTitle
    );
    
    return {
      ...tabConfig,
      actions: section?.actions || { view: false, edit: false, block: false }
    };
  });
};
